import { Invoice } from '../models/table-models';

/**
 * Дали в диалога „Промени“ да се предложи „Прихвани с КИ“: банкова фактура, по която вече е издадено
 * кредитно известие и по която нищо не е постъпило. Същите условия проверява и сървърът; тук е само
 * за да не се предлага бутон, който ще бъде отказан.
 */
export const isCreditNoteOffsetAvailable = (invoice?: Invoice): boolean => {
    const document = invoice?.document;
    return !!invoice && !!document
        && !invoice.isSaleInvoice
        && !invoice.creditNoteOffset
        && document.creditNoteNumber != null
        && document.invoiceNumber != null
        && document.paymentType?.toUpperCase() === 'BANK'
        && !document.paid && !invoice.paid
        && !document.paidAmount && !invoice.paidAmount;
};
